/*=========================================================================================
  File Name: moduleAlarm.js
  Description: Todo Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleAlarmState.js";
import mutations from "./moduleAlarmMutations.js";
import actions from "./moduleAlarmActions.js";
import getters from "./moduleAlarmGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
